import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import * as serviceWorker from './serviceWorker';
import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import { reducer } from '@app/Store'
import LogRocket from 'logrocket'

export const store = configureStore({ reducer })

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
if (process.env.REACT_APP_ENABLE_LOGROCKET.toLowerCase() !== 'false') {
    LogRocket.init('kvwmnv/capitaliz');
}
